import { JSX } from 'react'

import { IconProps } from '../../icon'

const EdubookFavText: (props: IconProps) => JSX.Element = ({
  dataTestId,
  height,
  id,
  stroke,
  title,
  width,
}: IconProps) => (
  <svg
    data-testid={dataTestId}
    fill='none'
    height={height || 48}
    id={id}
    stroke={stroke}
    viewBox='0 0 48 48'
    width={width || 48}
    xmlns='http://www.w3.org/2000/svg'
  >
    <title>{title}</title>
    <g clipPath='url(#clip0_2236_194)'>
      <path d='M48 0H0V48H48V0Z' fill='url(#paint0_linear_2236_194)' />
      <path
        d='M24.4163 41.0025L36.0319 38.5781L35.5557 36.2981L24.405 38.625L13.2563 36.2981L12.78 38.5781L24.3957 41.0025V41.0081L24.405 41.0063L24.4144 41.0081L24.4163 41.0025Z'
        fill='white'
      />
      <path
        d='M10.2544 11.9681H15.4519L15.1519 10.4344H8.07751V11.9681H10.2544Z'
        fill='white'
      />
      <path
        d='M13.905 16.2638L13.59 14.7169H10.2544H8.07751V16.2638H10.2544H13.905Z'
        fill='white'
      />
      <path
        d='M15.1519 19.1325H10.2544H8.07751V20.6494H15.4669L15.1519 19.1325Z'
        fill='white'
      />
      <path
        d='M23.3831 20.6494H22.3613L21.9113 19.9875C21.27 20.5481 20.5688 20.8294 19.8075 20.8294C18.675 20.8294 17.7825 20.4862 17.1263 19.8C16.47 19.1137 16.1419 18.1856 16.1419 17.0138C16.1419 16.2525 16.29 15.5813 16.5844 15C16.8788 14.4188 17.3081 13.9688 17.8688 13.6481C18.4294 13.3275 19.095 13.1681 19.8675 13.1681C20.1075 13.1681 20.3625 13.2113 20.6344 13.2956C20.9044 13.38 21.165 13.4981 21.4163 13.6481V10.2075L23.3831 10.0425V20.6475V20.6494ZM19.8825 19.1625C20.1431 19.1625 20.3963 19.1119 20.6419 19.0125C20.8875 18.9131 21.1444 18.7631 21.4163 18.5625V15.4537C21.1556 15.2344 20.9063 15.075 20.6644 14.9813C20.4244 14.8856 20.1638 14.8387 19.8825 14.8387C19.3519 14.8387 18.9319 15.0412 18.6206 15.4462C18.3094 15.8512 18.1556 16.3744 18.1556 17.0156C18.1556 17.6569 18.3075 18.1744 18.6131 18.57C18.9188 18.9656 19.3425 19.1625 19.8825 19.1625Z'
        fill='white'
      />
      <path
        d='M28.1306 19.2675C28.4719 19.2675 28.7906 19.1906 29.0925 19.035C29.3925 18.8794 29.7225 18.6712 30.0844 18.4125V13.365H32.0363V20.6512H30.7594L30.4294 19.8694C29.9794 20.19 29.4975 20.4394 28.9875 20.6213C28.4775 20.8013 28.0219 20.8912 27.6206 20.8912C26.7 20.8912 26.0531 20.6306 25.6838 20.1094C25.3125 19.5881 25.1288 18.8625 25.1288 17.9306V13.365H27.0806V17.8406C27.0806 18.2906 27.1725 18.6413 27.3581 18.8925C27.5438 19.1438 27.8006 19.2675 28.1325 19.2675H28.1306Z'
        fill='white'
      />
      <path
        d='M20.5144 33.0994C19.7325 33.0994 19.05 32.9438 18.4632 32.6344C17.8782 32.325 17.4244 31.8806 17.1038 31.305C16.7832 30.7294 16.6238 30.0562 16.6238 29.2837C16.6238 28.5112 16.7832 27.8363 17.1038 27.255C17.4244 26.6738 17.8782 26.2256 18.4632 25.9106C19.0482 25.5956 19.7325 25.4381 20.5144 25.4381C21.2963 25.4381 21.9788 25.5937 22.5657 25.9031C23.1507 26.2144 23.6044 26.6569 23.925 27.2325C24.2457 27.8081 24.405 28.4813 24.405 29.2538C24.405 30.0263 24.2457 30.7013 23.925 31.2825C23.6044 31.8638 23.1507 32.3119 22.5657 32.6269C21.9807 32.9419 21.2963 33.0994 20.5144 33.0994ZM22.3913 29.2538C22.3913 28.6219 22.2169 28.1063 21.8663 27.7069C21.5157 27.3056 21.0657 27.1069 20.5144 27.1069C19.9632 27.1069 19.5244 27.3131 19.17 27.7219C18.8138 28.1325 18.6375 28.6537 18.6375 29.2837C18.6375 29.9137 18.8119 30.4312 19.1625 30.8306C19.5132 31.2319 19.9632 31.4306 20.5144 31.4306C21.0657 31.4306 21.5025 31.2263 21.8588 30.8138C22.2132 30.4031 22.3913 29.8819 22.3913 29.2519V29.2538Z'
        fill='white'
      />
      <path
        d='M29.0475 33.0994C28.2656 33.0994 27.5831 32.9438 26.9963 32.6344C26.4113 32.325 25.9575 31.8806 25.6369 31.305C25.3163 30.7294 25.1569 30.0562 25.1569 29.2837C25.1569 28.5112 25.3163 27.8363 25.6369 27.255C25.9575 26.6738 26.4113 26.2256 26.9963 25.9106C27.5813 25.5956 28.2656 25.4381 29.0475 25.4381C29.8294 25.4381 30.5119 25.5937 31.0988 25.9031C31.6838 26.2144 32.1375 26.6569 32.4581 27.2325C32.7788 27.8081 32.9381 28.4813 32.9381 29.2538C32.9381 30.0263 32.7788 30.7013 32.4581 31.2825C32.1375 31.8638 31.6838 32.3119 31.0988 32.6269C30.5138 32.9419 29.8294 33.0994 29.0475 33.0994ZM30.9244 29.2538C30.9244 28.6219 30.75 28.1063 30.3994 27.7069C30.0488 27.3056 29.5988 27.1069 29.0475 27.1069C28.4963 27.1069 28.0575 27.3131 27.7031 27.7219C27.3469 28.1325 27.1706 28.6537 27.1706 29.2837C27.1706 29.9137 27.345 30.4312 27.6956 30.8306C28.0463 31.2319 28.4963 31.4306 29.0475 31.4306C29.5988 31.4306 30.0356 31.2263 30.3919 30.8138C30.7463 30.4031 30.9244 29.8819 30.9244 29.2519V29.2538Z'
        fill='white'
      />
      <path
        d='M36.2269 30.5306V32.9194H34.29V22.4794L36.2269 22.3144V28.2937L39.3506 25.425L40.4475 26.8069L38.4038 28.5938L41.0775 32.9194H38.8388L37.0069 29.8406L36.225 30.5306H36.2269Z'
        fill='white'
      />
      <path
        d='M14.2969 27.375C15.0281 26.805 15.3938 26.1975 15.3938 25.5581C15.3938 24.5775 15.0975 23.8556 14.5069 23.3944C13.9163 22.9331 13.095 22.7025 12.0431 22.7025H8.07751V24.3244H11.7581C12.2794 24.3244 12.6713 24.42 12.9375 24.6094C13.2019 24.7988 13.335 25.125 13.335 25.5863C13.335 26.0063 13.1644 26.325 12.825 26.5406C12.4838 26.7563 12.0281 26.8631 11.4581 26.8631H8.07751V28.44H12.2531C12.7444 28.44 13.1325 28.5694 13.4175 28.83C13.7025 29.0906 13.845 29.4563 13.845 29.9269C13.845 30.3675 13.6894 30.7088 13.38 30.9488C13.0688 31.1888 12.6488 31.3088 12.1181 31.3088H8.07751V32.9156H12.2681C13.3688 32.9156 14.2463 32.6475 14.8969 32.1112C15.5475 31.575 15.8738 30.8419 15.8738 29.91C15.8738 28.7681 15.3488 27.9225 14.2969 27.3713V27.375Z'
        fill='white'
      />
    </g>
    <defs>
      <linearGradient
        id='paint0_linear_2236_194'
        x1='-3.87563'
        y1='-3.87563'
        x2='48.5925'
        y2='48.5925'
        gradientUnits='userSpaceOnUse'
      >
        <stop stopColor='#FFBC38' />
        <stop offset='0.32' stopColor='#FF9A31' />
        <stop offset='1' stopColor='#FF4821' />
      </linearGradient>
      <clipPath id='clip0_2236_194'>
        <rect width='48' height='48' fill='white' />
      </clipPath>
    </defs>
  </svg>
)

export default EdubookFavText
